<template>
  <div class="lh-15 c-333">
    <ProductBanner
      :banner-img="bannerImg"
      :product-name="$t('common.productName.G2d')"
      :custom-style="{ top: '3rem', left: '2rem' }"
      :main-title="'FJD EASYDIG G21'"
      :sub-title="'2D EXCAVATOR GUIDANCE SYSTEM'"
      :product-img-style="{ backgroundImage: `url(${bannerProductImg})` }"
    />
    <div class="content p-r z-3 bgc-fff">
      <NavAnchor :product-name="$t('common.productName.G2d')" :spec-url="'/product/fjd-easy-dig-2d-excav-specs'" />
      <IconWrap class="area-1" :icon-wrap-data="iconWrapData" />
      <section class="area-2 pl-360 pr-360">
        <div class="area2-video-box d-f jc-sb c-b">
          <div class="video-box p-r">
            <video
              width="100%"
              height="100%"
              x5-playsinline
              x5-video-player-type="h5"
              x-webkit-airplay="allow"
              playsinline
              webkit-playsinline
              muted
              autoplay
              loop
              src="https://1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/da8d6403387702307003700069/xff8zkuPctkA.mp4"
              poster="https://1500006283.vod2.myqcloud.com/4384b243vodtranscq1500006283/da8d6403387702307003700069/sampleSnapshot/sampleSnapshot_10_0.jpg"
            ></video>
          </div>
          <div class="area2-desc">
            <h2 class="area2-h2 reveal">This is Easydig</h2>
            <p class="area2-content reveal">
              Easydig is a wireless 2D excavator guidance system that leads the industry with centimeter accuracy. It’s
              so easy to use that even newbies can get started quickly.
              <!-- <span class="in-pc pc-br"></span> -->
            </p>
            <p class="area2-content reveal">
              The 2D excavator guidance system comes with a modular design that allows you to switch between machines.
              Every operator can get it at an affordable price.
            </p>
          </div>
        </div>
      </section>

      <videoWrap
        :video-index="1"
        video-class="d-f jc-sb "
        :video-info="area3VideoInfo"
        :custom-style="{ width: '12rem' }"
        class="area-3"
      >
        <div class="labor-hours-warp">
          <div class="labor-hours-warp-col">
            <div class="item-warp d-f ai-c reveal">
              <svg-icon icon-class="bottom-arrow" class-name="arrow-bootom" />
              <span class="num">35%</span>
            </div>
            <div class="bottom-desc reveal">Labor Hours</div>
          </div>
          <div class="labor-hours-warp-col">
            <div class="item-warp d-f ai-c reveal">
              <svg-icon icon-class="bottom-arrow" class-name="arrow-bootom" />
              <span class="num">67.5%</span>
            </div>
            <div class="bottom-desc reveal">Labor Cost</div>
          </div>
          <div class="labor-hours-warp-col">
            <div class="item-warp d-f ai-c reveal">
              <svg-icon icon-class="bottom-arrow" class-name="arrow-bootom" />

              <span class="num">35%</span>
            </div>
            <div class="bottom-desc reveal">Diesel</div>
          </div>
        </div>
      </videoWrap>

      <!-- area-4 -->
      <section class="area-4 w-12r m-a">
        <h2 class="area-4-h2">Application Scenarios</h2>
        <div class="area4-img-warp d-f ai-c jc-sb">
          <div class="p-r" v-for="(item, index) in area4Data" :key="index">
            <img v-lazy="item.imgSrc" :alt="item.desc" class="area4-img" srcset="" />
            <div class="p-a area4-img-desc">{{ item.desc }}</div>
          </div>
        </div>
      </section>
      <!-- area5 轮播图 -->
      <Carousel
        class="w-12r m-a area5"
        ref="area5"
        :title="carouselTitle"
        :swiper-option="swiperOption"
        :swiper-data="swiperData"
      />
      <!-- area-6 -->
      <videoWrap
        id="features"
        :video-index="2"
        video-class="d-f jc-sb"
        :video-info="area6VideoInfo"
        :custom-style="{ width: '8.95rem' }"
        class="area-6 area-6-mt bgc-fafafa"
      ></videoWrap>
      <!-- area-7 -->
      <videoWrap
        :video-index="3"
        video-class="d-f jc-sb"
        :video-info="area7VideoInfo"
        :custom-style="{ width: '8.95rem' }"
        class="area-7"
      ></videoWrap>
      <!-- area8 轮播图 -->
      <Carousel
        class="area-8 bgc-fafafa"
        :carousel-wrap="{ width: '8.96rem', margin: '0 auto' }"
        ref="area8"
        :title="area8CarouselTitle"
        :swiper-option="area8swiperOption"
        :swiper-data="area8SwiperData"
      />
      <!-- area-9 -->
      <section class="area-9">
        <h2 class="area9-h2 w-12r m-a reveal">Compatibility</h2>
        <div class="area9-desc w-12r m-a reveal">Works with a variety of excavator brands</div>
        <img
          class="lazy-image area9-img d-b m-a reveal"
          v-lazy="require('@/assets/images/2d-excavator/compatible.jpg')"
          alt=""
        />
      </section>
      <!-- area-10 -->
      <section class="area-10">
        <div class="area10-warp">
          <h2 class="area10-h2">Online Service & OTA</h2>
          <ul class="d-f jc-sb ta-c fw-w pl-352 pr-352 m-icon-warp">
            <li class="reveal">
              <i class="m-a d-b"
                ><img
                  width="100%"
                  height="100%"
                  alt="Wireless Modules"
                  src="data:image/svg+xml,%3Csvg width='136' height='136' viewBox='0 0 136 136' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill-opacity='.01' fill='%23FFF' d='M0 0h136v136H0z'/%3E%3Cg transform='translate(22 28)'%3E%3Crect stroke='%23FFF' stroke-width='2' width='92' height='64.537' rx='9.2'/%3E%3Cpath d='M24.227 44.868c6.814 0 9.95-2.322 11.79-11.95.34-1.708.476-3.347.476-4.577 0-6.078-3.237-7.853-8.927-7.853-7.122 0-9.984 2.39-11.756 12.053-.306 1.64-.477 3.244-.477 4.508 0 6.044 2.965 7.82 8.894 7.82zm.136-3.585c-3.646 0-4.532-1.298-4.532-4.507 0-1.093.136-2.561.443-4.166 1.159-6.078 2.317-8.571 7.087-8.571 3.408 0 4.669 1.4 4.669 4.61 0 1.092-.205 2.595-.477 4.131-1.159 6.181-2.556 8.503-7.19 8.503zm22.353 3.244l3.85-19.942h6.44l.75-3.756h-17.31l-.75 3.756h6.577l-3.85 19.942h4.293zm11.823 0l3.476-6.317h9.643l.886 6.317h4.532l-3.85-23.698h-5.862L53.803 44.527h4.736zm12.642-9.766h-7.258l5.486-10.005h.409l1.363 10.005z' fill='%23FFF' fill-rule='nonzero'/%3E%3Cg stroke='%23FFF' stroke-width='2'%3E%3Cpath d='M37.823 64.537l-3.067 18.439M55.2 64.537l3.067 18.439'/%3E%3C/g%3E%3Cpath stroke='%23FFF' stroke-width='2' stroke-linecap='round' d='M23.511 82.976h46'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
                />
              </i>
              <strong class="d-b c-fff m-c-black">OTA Update</strong>
            </li>
            <li class="reveal">
              <i class="m-a d-b"
                ><img
                  width="100%"
                  height="100%"
                  alt="Centimeter"
                  src="data:image/svg+xml,%3Csvg width='136' height='136' viewBox='0 0 136 136' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M22.94 91.508h26.908c1.822 0 3.568.732 4.845 2.032l2.406 2.449a7.762 7.762 0 0 0 5.537 2.322h11.817a7.762 7.762 0 0 0 5.537-2.322l2.406-2.449a6.792 6.792 0 0 1 4.845-2.032h26.908a1.94 1.94 0 0 1 1.94 1.941v6.805a8.746 8.746 0 0 1-8.746 8.746H29.746A8.746 8.746 0 0 1 21 100.254V93.45a1.94 1.94 0 0 1 1.94-1.94z' stroke='%23FFF' stroke-width='2' stroke-linejoin='round'/%3E%3Cpath d='M28.762 91.994V40.977c0-3.756 3.041-6.802 6.792-6.802h38.812m33.96 20.407v-2.43 39.842' stroke='%23FFF' stroke-width='2'/%3E%3Cpath d='M79.218 23h34.93A4.851 4.851 0 0 1 119 27.851v19.364a4.851 4.851 0 0 1-4.851 4.851H94.743l-7.667 5.73a.97.97 0 0 1-1.551-.778v-4.952h-6.307a4.851 4.851 0 0 1-4.852-4.851V27.851A4.851 4.851 0 0 1 79.218 23z' stroke='%23FFF' stroke-width='2' stroke-linejoin='round'/%3E%3Ctext font-family='D-DIN-Bold, D-DIN' font-size='23.287' font-weight='bold' fill='%23FFF' transform='translate(21 23)'%3E%3Ctspan x='25.701' y='56.43'%3E24/7%3C/tspan%3E%3C/text%3E%3Cg transform='translate(85.04 36.119)' fill='%23FFF'%3E%3Cellipse cx='1.941' cy='1.944' rx='1.941' ry='1.944'/%3E%3Cellipse cx='11.644' cy='1.944' rx='1.941' ry='1.944'/%3E%3Cellipse cx='21.347' cy='1.944' rx='1.941' ry='1.944'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
                />
              </i>
              <strong class="d-b c-fff m-c-black m-c-black"
                >24/7 <br />
                Online Service</strong
              >
            </li>
            <li class="reveal">
              <i class="m-a d-b"
                ><img
                  width="100%"
                  height="100%"
                  alt="One-man Installation"
                  src="data:image/svg+xml,%3Csvg width='136' height='136' viewBox='0 0 136 136' xmlns='http://www.w3.org/2000/svg'%3E%3Cg stroke='%23FFF' stroke-width='2' fill='none' fill-rule='evenodd'%3E%3Cg transform='translate(23 38.372)'%3E%3Cellipse cx='40.228' cy='40.314' rx='27.82' ry='27.882'/%3E%3Cellipse cx='40.228' cy='40.314' rx='12.169' ry='27.598'/%3E%3Cpath d='M74.066 18.504a40.188 40.188 0 0 1 6.39 21.81c0 22.265-18.01 40.314-40.228 40.314a39.996 39.996 0 0 1-24.306-8.188L4.596 76.222a1.204 1.204 0 0 1-1.556-1.387l.037-.135L6.97 63A40.187 40.187 0 0 1 0 40.313C0 18.05 18.01 0 40.228 0c3.723 0 7.327.507 10.749 1.455' stroke-linejoin='round'/%3E%3Cpath d='M12.689 40.956h55.079'/%3E%3C/g%3E%3Cpath d='M92.617 11C103.874 11 113 20.17 113 31.483c0 10.723-9.316 18.01-14.947 23.433-4.41 4.246-5.436 6.809-5.436 6.809s-1.178-2.785-5.435-6.81c-5.715-5.401-14.947-12.532-14.947-23.489C72.235 20.114 81.36 11 92.617 11z' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cg transform='translate(81.841 18.822)'%3E%3Cellipse cx='10.808' cy='6.145' rx='5.944' ry='6.145'/%3E%3Cpath d='M4.609 16.054h12.397a4.609 4.609 0 0 1 4.61 4.609v4.113a.495.495 0 0 1-.496.496H.495A.495.495 0 0 1 0 24.776v-4.113a4.609 4.609 0 0 1 4.609-4.61z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
                />
              </i>
              <strong class="d-b c-fff m-c-black">Local Support <br />(Availability Depends) </strong>
            </li>
            <li class="reveal">
              <i class="m-a d-b"
                ><img
                  width="100%"
                  height="100%"
                  alt="100H Battery Life"
                  src="data:image/svg+xml,%3Csvg width='136' height='136' viewBox='0 0 136 136' xmlns='http://www.w3.org/2000/svg'%3E%3Cg transform='translate(26 22)' stroke='%23FFF' stroke-width='2' fill='none' fill-rule='evenodd'%3E%3Cpath d='M54.274 86.73A60.08 60.08 0 0 1 41.028 93C16.528 84.878 0 62.06 0 36.358V12.917L41.023 0l41.024 12.917v23.451c0 9.139-2.09 17.913-5.885 25.791' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M67.22 26.757c3.242 6.173 2.287 13.95-2.877 19.108-6.368 6.361-16.729 6.326-23.14-.08-6.413-6.404-6.448-16.751-.08-23.113 5.164-5.156 12.951-6.109 19.132-2.872l-9.85 9.838 6.966 6.958 9.849-9.839z' stroke-linejoin='round'/%3E%3Cpath d='M38.467 41.13c-3.191 3.187-9.21 9.216-20.623 20.655-1.112 1.112-1.187 2.839-.166 3.858l3.698 3.692c1.021 1.02 2.75.946 3.863-.166A22985.536 22985.536 0 0 1 45.815 48.56'/%3E%3Cg stroke-linecap='round'%3E%3Cpath d='M48.275 33.296l-4.656 4.655M53.706 38.727l-4.655 4.656'/%3E%3C/g%3E%3Cellipse cx='67.395' cy='76.358' rx='16.605' ry='16.642'/%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M59.695 76.23l5.906 6.002 11.562-11.748'/%3E%3C/g%3E%3C/svg%3E"
                />
              </i>
              <strong class="d-b c-fff m-c-black"
                >2-Year
                <br />
                Warranty</strong
              >
            </li>
          </ul>
        </div>
      </section>
      <!-- area-11 -->
      <section class="area-11 bgc-fafafa">
        <h2 class="area11-h2 reveal">2 Different Systems Configurations</h2>
        <div class="w-12r d-f jc-sb area11-img-warp">
          <div>
            <a href="/product/fjd-easy-dig-g21-2d-excav" title="fjd easy dig 2d excav" one-link-mark="yes">
              <img
                class="area11-img"
                v-lazy="require('@/assets/images/3d-excavator/area9-1.png')"
                alt="fjd easy dig 2d excav"
              />
            </a>
            <!-- ../images/3d-excavator/area9-1.png -->
            <div class="area11-title reveal">2D Excavator Guidance System</div>
            <ul class="area11-ul">
              <li class="reveal">
                <span>Affordable price</span>
              </li>
              <li class="reveal">
                <span>Wireless modules</span>
              </li>
              <li class="reveal">
                <span>Easy to install & calibrate</span>
              </li>
              <li class="reveal">
                <span>Beginner friendly</span>
              </li>
            </ul>
          </div>
          <div>
            <a href="/product/excavatorguidance" title="FJD 3D Excavator Guidance System" one-link-mark="yes">
              <img
                class="area11-img"
                v-lazy="require('@/assets/images/3d-excavator/area9-2.png')"
                alt="FJD 3D Excavator Guidance System"
              />
            </a>
            <div class="area11-title reveal">3D Excavator Guidance System</div>
            <ul class="area11-ul">
              <li class="reveal">
                <span>3cm accuracy</span>
              </li>
              <li class="reveal">
                <span>3D visual guidance</span>
              </li>
              <li class="reveal">
                <span>Site design</span>
              </li>
              <li class="reveal">
                <span>Tilt bucket support</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="area11-tip reveal">Note: please contact our Sales Team for customized solutions.</div>
      </section>
      <!-- blog -->
      <BlogCard :blog-data="blogData" class="area-12" />
    </div>
  </div>
</template>

<script>
  // import { gsap } from 'gsap'
  // import { ScrollTrigger } from 'gsap/dist/ScrollTrigger.js'
  import bannerImg from '@/assets/images/2d-excavator/banner.jpg'
  import bannerProductImg from '@/assets/images/2d-excavator/banner-pic.png'

  import area4Img1 from '@/assets/images/2d-excavator/road-construction.jpg'
  import area4Img2 from '@/assets/images/2d-excavator/trenches.jpg'
  import area4Img3 from '@/assets/images/2d-excavator/swimming-pools.jpg'
  import area4Img4 from '@/assets/images/2d-excavator/residential-projects.jpg'
  import area4Img5 from '@/assets/images/2d-excavator/foundations.jpg'
  import area4Img6 from '@/assets/images/2d-excavator/car-parks.jpg'

  import Carousel from '@/components/Carousel/Carousel'

  import ProductBanner from '@/components/ProductBanner'
  import NavAnchor from '@/components/NavAnchor'
  import IconWrap from '@/components/IconWrap'
  import videoWrap from '@/components/videoWrap'

  import BlogCard from '@/components/BlogCard'
  import bannerScroll from '@/mixins/bannerScroll.js'

  const area5TabItem = ['Slope Cutting & Deep Excavation ', 'Site Design', '3D Visual Guidance']
  const area8TabItem = ['Control Terminal', 'Wireless Sensor', 'Calibration Laser Package']

  export default {
    components: {
      ProductBanner,
      NavAnchor,
      IconWrap,
      videoWrap,
      Carousel,
      BlogCard
      // Carousel,
      // leftRightCarousel
      // Application,
      // CustomerCard,
      //
    },
    mixins: [bannerScroll],
    data() {
      const vm = this
      return {
        bannerImg,
        bannerProductImg,
        blogData: [],
        iconWrapData: [
          {
            icon: '2d-wireless-modules',
            vHtml: 'Wireless<br/>Modules'
          },
          {
            icon: '2d-centimeter-accurancy',
            vHtml: 'Centimeter<br/>Accurancy'
          },
          {
            icon: '2d-one-man-installation',
            vHtml: 'One-man <br/>Installation'
          },
          {
            icon: '2d-100h',
            vHtml: '100H <br/>Battery Life'
          },
          {
            icon: '2d-solar-charging',
            vHtml: 'Solar <br/>Charging'
          },
          {
            icon: '2d-entry-level',
            vHtml: 'Entry-Level<br/>Friendly'
          }
        ],
        imgDescData: [
          {
            videoSrc:
              'https://1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/da8d6403387702307003700069/xff8zkuPctkA.mp4',
            imgSrc:
              'https://1500006283.vod2.myqcloud.com/4384b243vodtranscq1500006283/da8d6403387702307003700069/sampleSnapshot/sampleSnapshot_10_0.jpg',
            title: 'This is Easydig',
            desc: '<p class="area2-content reveal">Easydig is a wireless 2D excavator guidance system that leads the industry with centimeter accuracy. It’s so easy to use that even newbies can get started quickly.</p><p class="area2-content reveal">The 2D excavator guidance system comes with a modular design that allows you to switch between machines. Every operator can get it at an affordable price.</p>'
          }
        ],
        area3VideoInfo: {
          h2: 'Key Benefits',
          desc: 'Digital Construction VS Traditional Construction',
          isImg: true,
          poster: require('@/assets/images/2d-excavator/key-benefits.jpg')
        },
        area4Data: [
          {
            imgSrc: area4Img1,
            desc: 'Road Construction'
          },
          {
            imgSrc: area4Img2,
            desc: 'Trenches'
          },
          {
            imgSrc: area4Img3,
            desc: 'Swimming Pools'
          },
          {
            imgSrc: area4Img4,
            desc: 'Residential Projects'
          },
          {
            imgSrc: area4Img5,
            desc: 'Foundations'
          },
          {
            imgSrc: area4Img6,
            desc: 'Car Parks'
          }
        ],
        carouselTitle: 'Entry-level Friendly',
        swiperOption: {
          // loop: true,
          slidesPerView: 1,
          spaceBetween: 0,
          effect: 'slide',
          pagination: {
            el: '.area-8-swiper-tab',
            clickable: true,
            renderBullet(index, className) {
              return '<span class="' + className + '">' + vm.$t(area5TabItem[index]) + '</span>'
            }
          },
          on: {
            init() {
              vm.videos = document.querySelectorAll('.area-8-swiper video')
              const playPromise = vm.videos[0].play()
              if (playPromise !== undefined) {
                playPromise
                  .then(() => {
                    vm.videos[0].play()
                  })
                  .catch((e) => {
                    console.log('[ e ] >', e)
                  })
              }
            },
            slideChange() {
              const index = this.realIndex
              // console.log('[ vm.$refs ] >', vm.$refs)
              vm.$refs.area5.$refs.swiperLine.style.transform = `translateX(${index * 100}%)`
              const curPlayVideo = vm.videos[index]
              curPlayVideo.play()
            }
          }
        },
        swiperData: [
          {
            videoSrc:
              'https://1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/8ba80b8e387702307240657048/GbYpRLk22pUA.mp4',
            img: 'https://1500006283.vod2.myqcloud.com/4384b243vodtranscq1500006283/0560de6c387702306894007430/sampleSnapshot/sampleSnapshot_10_0.jpg',
            desc: 'The centimeter accuracy enabled by algorithm lets you know the precise position of the bucket teeth, so you can avoid over-dig and under-dig, and cut slopes to your desired grade easily.'
          },
          {
            videoSrc:
              'https://1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/8730d6cd387702307240481709/kva8hTazA7kA.mp4',
            img: 'https://1500006283.vod2.myqcloud.com/4384b243vodtranscq1500006283/cdbf78b7387702306893957023/sampleSnapshot/sampleSnapshot_10_0.jpg',
            desc: 'Set your target depth, width, length, and grade right on the site and get started in no time.'
          },
          {
            videoSrc:
              'https://1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/bd437aef387702306893230922/Z0FQeM3w9d0A.mp4',
            img: 'https://1500006283.vod2.myqcloud.com/4384b243vodtranscq1500006283/bd437aef387702306893230922/sampleSnapshot/sampleSnapshot_10_0.jpg',
            desc: '3D real-time animation guidance helps avoid repeated measurement and rework.'
          }
        ],
        area6VideoInfo: {
          h2: 'Interface Customization',
          desc: 'The HMI system provides 8 perspectives and 4 interface view modes, which can be freely combined and presented according to work habits and needs.',
          poster:
            'https://1500006283.vod2.myqcloud.com/4384b243vodtranscq1500006283/0859d38b387702306822815350/sampleSnapshot/sampleSnapshot_10_0.jpg',
          src: 'https://1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/0859d38b387702306822815350/XbRgFeuX8xQA.mp4'
        },
        area7VideoInfo: {
          h2: 'One-man Installation',
          desc: 'With the modular and wireless design, this 2D excavator grade control system is easy to set up and switch between machines.',
          poster:
            'https://1500006283.vod2.myqcloud.com/4384b243vodtranscq1500006283/c1f067cd387702306893435103/sampleSnapshot/sampleSnapshot_10_0.jpg',
          src: 'https://1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/c1f067cd387702306893435103/gKbR6XoILvAA.mp4'
        },
        area8CarouselTitle: 'Core Components',
        area8swiperOption: {
          // loop: true,
          slidesPerView: 1,
          spaceBetween: 0,
          effect: 'slide',
          pagination: {
            el: '.area-8-swiper-tab',
            clickable: true,
            renderBullet(index, className) {
              return '<span class="' + className + '">' + vm.$t(area8TabItem[index]) + '</span>'
            }
          },
          on: {
            init() {
              vm.videos = document.querySelectorAll('.area-8-swiper video')
              const playPromise = vm.videos[0].play()
              if (playPromise !== undefined) {
                playPromise
                  .then(() => {
                    vm.videos[0].play()
                  })
                  .catch((e) => {
                    console.log('[ e ] >', e)
                  })
              }
            },
            slideChange() {
              const index = this.realIndex
              // console.log('[ vm.$refs ] >', vm.$refs)
              vm.$refs.area8.$refs.swiperLine.style.transform = `translateX(${index * 100}%)`
              const curPlayVideo = vm.videos[index]
              curPlayVideo.play()
            }
          }
        },
        area8SwiperData: [
          {
            img: require('@/assets/images/2d-excavator/area8-1.png'),
            isHtml: true,
            isImg: true,
            vHtml:
              '<div style="height:1.3rem"><p>10.1" touch screen.</p><p>Built-in WiFi, Bluetooth, and Radio.</p><p>Visible HMI displays real-time operation information.</p></div>'
          },
          {
            img: require('@/assets/images/2d-excavator/area8-3.png'),
            vHtml:
              '<p style="height:1.3rem">Wireless sensors detect the attitude of the boom, stick, and bucket. With solar charging and an on/off switch, they can be easily reinstalled on another excavator without maneuvering cables.</p>',
            isImg: true,
            isHtml: true
          },
          {
            img: require('@/assets/images/2d-excavator/area8-2.png'),
            isHtml: true,
            vHtml:
              '<div style="height:1.3rem"><p>Laser: Used to automatically calibrate the length of the boom and stick and correct the angle deviation of the boom and stick sensors.</p><p>Magnetic Bar: Attached to the linkage pin for calibrating the boom, stick, and bucket.</p><p>Telescopic Tube: For adjusting laser height.</p></div>',
            isImg: true
          }
        ]
      }
    },
    head() {
      return {
        title: 'FJD Easydig 2D excavator guidance system',
        meta: [
          {
            hid: 'keywords',
            name: 'keywords',
            content:
              'grade control,excavator guidance system,2D grade control,2D excavator grade control,2D excavator guidance,system,digital construction,machine control'
          },
          // hid is used as unique identifier. Do not use `vmid` for it as it will not work
          {
            hid: 'description',
            name: 'description',
            content:
              'Easydig is a wireless 2D excavator guidance system that leads the industry with centimeter accuracy.'
          }
        ]
      }
    },
    created() {},
    mounted() {
      this.processProductIdBlog()
      // eslint-disable-next-line nuxt/no-env-in-hooks
    },
    methods: {
      async processProductIdBlog() {
        // getProductIdBlog
        const { data } = await this.$api.blogApi.getProductIdBlog({
          languageCode: 'en-US',
          productId: '5'
        })
        this.blogData = data
      }
    }
  }
</script>

<style scoped lang="scss">
  .content h2 {
    font-size: 0.48rem;
  }

  /* area-1 */
  .area-1 {
    height: 6.84rem;
    background-image: url('@/assets/images/2d-excavator/area1-bg.jpg');
    background-attachment: fixed;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  :deep(.area-1 .text) {
    color: #fff;
  }

  /* area-2 */
  .area-2 {
    padding: 1.6rem 3.6rem 0 3.6rem;
  }
  .video-box {
    width: 7.44rem;
    height: 4.19rem;
    box-sizing: border-box;
    margin-right: 0.32rem;
  }
  .area2-h2 {
    height: 0.72rem;
    font-size: 0.48rem;
    font-weight: bold;
    color: #333333;
    line-height: 0.72rem;
    margin-bottom: 0.32rem;
  }
  .area2-content {
    margin-bottom: 0.32rem;

    width: 4.24rem;
    font-size: 0.18rem;
    font-weight: 400;
    color: #666666;
    line-height: 0.26rem;
  }
  .pc-br {
    display: block;
    height: 0.32rem;
  }
  // area-3
  :deep(.area-3) {
    .img-box {
      width: 9.72rem;
      height: 5.46rem;
    }
    .video-box {
      height: 5.46rem;
    }
  }

  .labor-hours-warp {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
  }
  .arrow-bootom {
    width: 0.17rem;
    height: 0.3rem;
    margin-right: 0.18rem;
  }
  .item-warp {
    border-bottom: 1px solid #333333;
    margin-top: 0.28rem;
    /* padding-bottom: 0.04rem; */
    // width: 1.76rem;
    justify-content: center;
  }
  .num {
    font-size: 0.48rem;
    font-weight: bold;
    color: #333;
    line-height: 1.2;
  }
  .bottom-desc {
    font-size: 0.24rem;
    font-weight: 500;
    color: #333;
    margin-top: 0.12rem;
    text-align: center;
  }
  // area-4
  .area-4 {
    padding-top: 1.6rem;
  }
  .area-4-h2 {
    margin-bottom: 0.32rem;
    font-size: 0.48rem;
    font-weight: bold;
    color: #333333;
    text-align: center;
  }
  .area4-img-warp {
    flex-wrap: wrap;
  }
  .area4-img {
    width: 3.92rem;
    height: 3.92rem;
    margin-bottom: 0.12rem;
  }
  .area4-img-desc {
    bottom: 0.36rem;
    left: 0.24rem;
    font-size: 0.24rem;
    font-weight: 500;
    color: #ffffff;
  }
  .area-6 {
    padding: 1.12rem 0;
  }
  .area-6-mt {
    margin-top: 0;
  }
  // area-8
  .area-8 {
    margin-top: 1.6rem;
  }
  :deep(.area-8 .area-8-swiper .img-box) {
    width: 7.44rem;
    height: 4rem;
    margin: 0 auto 1.32rem auto;
    display: block;
    background-color: #fafafa;
    box-sizing: border-box;
  }
  :deep(.area-8 .area-8-swiper-tab-wrap) {
    top: 4rem;
    padding-top: 0.32rem;
  }
  :deep(.area-8 h2) {
    margin-bottom: 0;
  }
  :deep(.area-8 .swiper-slide-active .text) {
    margin-top: 1.32rem;
    height: 1.3rem;
  }
  :deep(.swiper-carousel) {
    padding: 1rem 0 1.6rem 0;
  }
  /* area-9 */
  .area-9 {
    padding-top: 1.6rem;
  }
  .area9-h2 {
    font-size: 0.48rem;
    font-weight: bold;
    color: #333333;
    text-align: center;
    margin-bottom: 0.24rem;
  }
  .area9-desc {
    font-size: 18px;
    font-weight: 400;
    margin-bottom: 0.32rem;
    text-align: center;
    color: #666666;
  }
  .area9-img {
    width: 12rem;
  }
  // area-10
  .pr-352 {
    padding-right: 3.52rem;
  }
  .pl-352 {
    padding-left: 3.52rem;
  }
  .area-10 {
    padding-top: 1.6rem;
  }
  .area10-warp {
    background-image: url('@/assets/images/2d-excavator/online-service.jpg');
    height: 6.2rem;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }
  .area10-h2 {
    padding-top: 1.4rem;
    font-size: 0.48rem;
    font-weight: bold;
    color: #ffffff;
    text-align: center;
    margin-bottom: 0.64rem;
  }
  .area-10 ul li {
    flex: 1;
  }
  .area-10 ul li img {
    width: 1.36rem;
    height: 1.36rem;
  }
  .area-10 ul li strong {
    font-size: 0.2rem;
    font-weight: 400;
    color: #ffffff;
  }
  .area-11 {
    padding: 1.2rem 3.6rem 0.8rem;
  }
  .area11-h2 {
    margin: 0 auto;
    width: 12rem;
    font-size: 0.48rem;

    font-weight: bold;
    color: #333333;
    margin-bottom: 0.32rem;
    text-align: center;
  }
  .area-11 .area11-img {
    margin-bottom: 0.24rem;
    width: 5.16rem;
    transition: transform 0.3s linear;
    height: 2.91rem;
    cursor: pointer;
  }
  .area-11 .area11-img:hover {
    transform: scale(1.1);
  }
  .area11-title {
    font-size: 0.24rem;
    font-weight: 500;
    color: #333333;
    /* text-align: center; */
    margin-bottom: 0.08rem;
  }
  .area11-ul {
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;
    margin-left: 0.2rem;
  }
  .area11-ul li {
    margin-bottom: 0.04rem;
    list-style-type: disc;
    color: #666666;
  }
  .area11-ul li::marker {
    background: #999999;
    color: #999999;
  }
  .area11-tip {
    float: right;
    font-size: 0.18rem;
    font-weight: 400;
    color: #bbbbbb;
    margin-right: -2.4rem;
  }
  .area-12 {
    padding-top: 1.6rem;
  }
  // banner 产品图
  :deep(.banner-product-img) {
    width: 7.1rem;
    height: 2.945rem;
    top: 4.42rem;
    right: 2.03rem;
  }
  :deep(.area5) {
    .area-8-swiper .img-box {
      height: auto;
    }
    .area-8-swiper-tab-wrap {
      top: 7.52rem;
    }
  }
  :deep(.area-6 .video-box) {
    height: 6.75rem;
  }
  :deep(.area-7 .video-box) {
    height: 6.75rem;
  }
  :deep(.area-8) {
    padding: 1rem 0;
  }
</style>
